export default __webpack_public_path__ + "static/media/attivita.e91829f2.svg";